import { tickerUpdates } from '@/mocks/home';

export default function TopTicker() {
  const loop = [...tickerUpdates, ...tickerUpdates];

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex h-9 max-w-[1400px] items-center gap-4 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 text-xs font-medium tracking-wide">
          <span className="flex h-4 w-4 items-center justify-center">
            <span className="block h-1.5 w-1.5 rounded-full bg-primary-400 animate-hly-pulse" />
          </span>
          实时追踪
        </span>

        <span className="hidden h-4 w-px shrink-0 bg-background-100/25 sm:block" />

        <div className="hly-marquee relative hidden flex-1 overflow-hidden sm:block">
          <div className="flex w-max animate-hly-marquee items-center">
            {loop.map((item, i) => (
              <span key={`${item.time}-${i}`} className="flex items-center whitespace-nowrap pr-10 text-xs text-background-200">
                <span className="mr-2 font-mono text-[11px] text-accent-400">{item.time}</span>
                {item.text}
              </span>
            ))}
          </div>
        </div>

        <a
          href="#updates"
          className="ml-auto flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-background-200 transition-colors hover:text-accent-400"
        >
          全部更新
          <i className="ri-arrow-right-s-line text-sm" />
        </a>
      </div>
    </div>
  );
}